@if (control) {
<div class="mb-3 pb-2 position-relative divide">
  <label for="{{getControlName(control)}}" class="form-label">{{ label }}</label>
  <span *ngIf="isFieldRequired(control)" class="text-danger">*</span>
  <select class="form-select divide-input" [formControl]="control" id="{{getControlName(control)}}"
    [required]="isFieldRequired(control)" [attr.multiple]="multiple ? '' : null">

    <option value="" [selected]="!control.value" disabled hidden>
      {{ placeholder || '- Please Select -' }}
    </option>
     <option value="">-- None --</option>

    <option *ngFor="let option of options" [value]="isObject(option) ? option.key : option">
      {{ isObject(option) ? option.value : option }}
    </option>
  </select>
  <div class="invalid-feedback d-block">
    <div *ngFor="let error of control.errors | errorKeys : label">
      <div *ngIf="control.touched">
        {{ error }}
      </div>
    </div>
  </div>
</div>
}
